var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileManageSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.857 17.5H1V.5h4.857v17zm-3.643-1.214h2.429V1.714H2.214v14.572zm9.107 1.214H6.464V.5h4.857v17zM7.68 16.286h2.428V1.714H7.68v14.572zm9.107 1.214h-4.857V.5h4.857v17zm-3.643-1.214h2.428V1.714h-2.428v14.572zM1.607 2.625h3.036v1.214H1.607V2.625zm5.464 0h3.036v1.214H7.071V2.625zm5.768 0h3.036v1.214h-3.036V2.625zM1.607 9.911h3.036v1.214H1.607V9.911zm5.464 0h3.036v1.214H7.071V9.911zm5.768 0h3.036v1.214h-3.036V9.911zM2.821 12.036h1.215v.91H2.82v-.91zm5.465 0H9.5v.91H8.286v-.91zm5.464 0h1.214v.91H13.75v-.91z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
export default SvgFileManageSvg;